import { Actions } from '../constants';

export default function showModal(payload) {
  return {
    type: Actions.SHOW_MODAL,
    payload,
  };
}
